import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { gameActions } from "../../action/GameAction";
import moment from 'moment';
import Header from "../../Header/Header";
import { Helmet } from "react-helmet";
import { history } from "../../helpers/history";
import { commonClass } from "../../helpers/commonClass";
import PriceBreakdown from "../Home/PriceBreakdown";

class WinnersList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lottoType: props.drawType,
            startDate: moment().subtract(29, 'days'),
            endDate: moment(),
            currentPageNo: 0,
            NumberofRecord: 5,
            totalPage: 0,
            startinx: 0,
            endinx: 10,
            lfilterdt: [],
            MainDrawAllwinner: []
        }
    }



    static getDerivedStateFromProps(Props, prevState) {
        if (Props.RaffleResult && Props.RaffleResult.RaffleResultLst && Props.RaffleResult.RaffleResultLst !== prevState.prevRaffleResultLst) {
            const filteredWinners = Props.RaffleResult.RaffleResultLst.filter((a) => a.draws_type === "1");
            return {
                MainDrawAllwinner: filteredWinners,
                prevRaffleResultLst: Props.RaffleResult.RaffleResultLst,
                breakdownlist: Props.RaffleResult && Props.RaffleResult.breakdownlist,
                previousResult: Props.previousResult,
            };
        }

        return null; // no state update needed
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.MainDrawAllwinner !== prevState.MainDrawAllwinner) {
            this.LoadTransactionData();
        }
    }

    createTickBall = (x) => {
        let ballLst = [];
        for (let i = 1; i <= x.max_ball; i++) {
            if (x.matchingball >= i)
                ballLst.push(<span className={`lto-${this.state.lottoType}-bg-color lto-${this.state.lottoType}-border`}><img src="./assets/img/icons/star.png?v0.1" draggable="false" /></span>)
            else
                ballLst.push(<span className={`lto-${this.state.lottoType}-border`}></span>)
        }
        return ballLst;
    }

    loadnxtdata = (st) => {
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        else if (st == "first") {
            this.state.currentPageNo = 0;
        }
        else if (st == "last") {
            this.state.currentPageNo = this.state.totalPage;
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }

    LoadTransactionData = () => {
        if (this.state.MainDrawAllwinner && this.state.MainDrawAllwinner && this.state.MainDrawAllwinner.length > 0) {
            let ldt = []
            ldt = this.state.MainDrawAllwinner;
            this.setState({ lfilterdt: ldt });
            let ltotpage = Math.trunc(ldt.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(ldt.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }


    render() {
        window.allDrawResultPopUp();
        const { t } = this.props;
        let unique = [];
        if (this.state.MainDrawAllwinner) {
            unique = [...new Set(this.state.MainDrawAllwinner.map(item => item.draws_type))]
        }
        return (
            <>
                {/* <PriceBreakdown lottoType={this.state.lottoType} /> */}
                <h2 class="headding2 padding-bottom-10"><span>{t('lblPriceBreak')}</span></h2>
                <div class="prizeBrkContain">
                    <div class="prizeBrkCont">
                        {this.state.breakdownlist && this.state.breakdownlist && Array.isArray(this.state.breakdownlist)
                            && this.state.breakdownlist.map((gObj, ginx) =>
                                <>
                                    <div class="prizeBrkPly">
                                        <div class="lottoRatings">
                                            <p>{gObj.max_ball} {t('lblOutOf')} {gObj.matchingball}</p>
                                            <div class="pBrDnBalls">
                                                {this.createTickBall(gObj)}
                                            </div>
                                            <div class="pBrDnPriDls">
                                                <div class="bg-game14">
                                                    <div class="grandPrice">{gObj.pricetext}</div>
                                                    <span>{this.props.appvariables.currency} {commonClass.aedCrnyConvert(gObj.winamt)} {gObj.starFlag && gObj.starFlag == "1" ? "*" : ""}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                    </div>
                </div>


                <h2>{t('lblMainDrawResult')}</h2>
                <>
                    <div class="favourites">
                        <div class="latestDrawRslt padding-bottom-0">
                            <ul>
                                <li>
                                    <div class="w-30 head">{t('lblWinningCombination')}</div>
                                    <div class="w-20 head">{t('lbldate')}</div>
                                    <div class="w-15 head">{t('lblTotalPrize')}</div>
                                    <div class="w-15 head">{t('lblTotalWinners')}</div>
                                    <div class="w-20 head">&nbsp;</div>
                                </li>
                                {Object.keys(this.props.PastDrawStateObj) && Object.keys(this.props.PastDrawStateObj).length > 0 &&
                                    <li class={`lto-${this.state.lottoType}`}>
                                        <div class="w-30">
                                            {this.props.PastDrawStateObj.win_number && this.props.PastDrawStateObj.win_number.split(';').length > 0 && this.props.PastDrawStateObj.win_number.split(';').map((winNos, index) =>
                                                <div class={`lottoRsltBalls lto-${this.state.lottoType}-bg-color`}>{winNos}</div>
                                            )}
                                        </div>
                                        <div class="w-20">{this.props.PastDrawStateObj && this.props.PastDrawStateObj.draw_date.replace(',', ' ')}</div>
                                        <div class="w-15 bold">{this.props.appvariables.currency} {commonClass.aedCrnyConvert(this.props.PastDrawStateObj.total_prize)}</div>
                                        <div class="w-15">{this.props.PastDrawStateObj.total_winner}</div>
                                        <div class="w-20 winBtn">
                                            {/* <a onClick={() => { this.GetLatestWinner(this.props.PastDrawStateObj) }}></a> */}
                                        </div>
                                    </li>}
                            </ul>
                        </div >
                    </div >
                </>
                {(unique && unique.length > 0) ?
                    unique.map((obj, inx) =>
                        // Main Draw Results
                        obj == 1 && <>
                            <h2>{t('lblMainDrawResult')}</h2>
                            <div class="favourites">
                                <div class="latestDrawRslt padding-bottom-0">
                                    <ul>
                                        <li>
                                            <div class="w-30 head">{t('lblname')}</div>
                                            <div class="w-20 head">{t('lblage')}</div>
                                            <div class="w-35 head">{t('lblPurchase')}</div>
                                            <div class="w-15 head">{t('lblWon')}</div>
                                            {/* <div class="w-20 head">&nbsp;</div> */}
                                        </li>
                                        {this.state.lfilterdt && this.state.lfilterdt.length > 0 && this.state.lfilterdt.slice(this.state.startinx, this.state.endinx).map((result, index) =>
                                            <li class={`lto-${this.state.drawType}`}>
                                                <div class="w-30 bold">  {result.Player_name} </div>
                                                {result.Player_age && result.Player_age.length > 0 ? < div class="w-20">{result.Player_age} &nbsp;&nbsp; {t('lblOld')}</div>
                                                    : < div class="w-20">-</div>}
                                                <div class="w-35">
                                                    {result.raffleid && result.raffleid.split('^')[0].split(';').map((ballNo, ind) =>
                                                        <div class={`lottoRsltBalls lto-${this.state.lottoType}-bg-color`}>{ballNo}</div>
                                                    )}</div>
                                                <div class="w-15 bold">{this.props.appvariables.currency} {commonClass.aedCrnyConvert(result.winamount)}</div>
                                            </li>
                                        )
                                        }
                                    </ul>
                                </div >
                            </div >

                            <div class="pagination">
                                <div class="paginationLft">
                                    {t('lblshowing')} <span>{this.state.currentPageNo + 1}</span> {t('lblto')} <span>{Math.ceil(this.state.MainDrawAllwinner.length / this.state.NumberofRecord)}</span> {t('lblof')}  <span>{this.state.MainDrawAllwinner && this.state.MainDrawAllwinner.length}</span> {t('lblentries')}
                                </div>
                                <div class="paginationLRht">
                                    <a onClick={() => this.loadnxtdata("first")}><img src="./assets/img/icons/paginate-2-lft.png" /></a>
                                    <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                                    <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                                    <a onClick={() => this.loadnxtdata("last")} class="" ><img src="./assets/img/icons/paginate-2-rht.png" /></a>
                                </div>
                            </div>
                        </>
                    )
                    : <div className={`winnersList ${this.props.drawType == 1 ? "bg1Fade15" : "bg2Fade15"} border-radius-none`}>
                        <p className='marginAuto' style={{ textAlign: "center" }}>{t('lblresultprogress')}</p>
                        {/* <p className='marginAuto' style={{ textAlign: "center" }}>{t('lblNoRecordFound')}</p> */}
                    </div>
                }
            </>

            // <div id="popup-container1" className="popup-container1 bigpopup">
            //     <div id="popup-content" className="popup-content1 min-width-65 no-scrollbar">
            //         <div id="rightAlign" className="rightAlign">
            //             <button id="close-popup1" className="close-popup1 bigpopupclose">
            //                 <img src="./assets/img/icons/Close-Btn.svg" alt="Close icon" />
            //             </button>
            //         </div>
            //         <div className={`popup-main bg-game${this.props.drawType}`} >
            //             <div className="viewLatestHead2">
            //                 <div className="dateDraw">
            //                     <div>{this.props.PastDrawStateObj && this.props.PastDrawStateObj.draw_date && <> {this.props.PastDrawStateObj.draw_date.split(',')[0]} {this.props.PastDrawStateObj.draw_date.split(',')[1].split(' ')[0]}</>}</div>
            //                     <div>{this.props.PastDrawStateObj && this.props.PastDrawStateObj.draw_date && this.props.PastDrawStateObj.draw_date.split(',')[1].split('  ')[1]}</div>
            //                 </div>
            //                 <div className="drawHeader">
            //                     <div>{t('lblPastdraw')}</div>
            //                     <div>{t('lblResult')}</div>
            //                 </div>
            //             </div>

            //             <div className="winnersList1">
            //                 <div className={`columns-2 ${(this.props.drawType == 6 || this.props.drawType == 1) ? 'columnsrush3' : ''}`}>
            //                     <div className={`bg-game${this.props.drawType}fade ${this.props.drawType == 13 ? 'min-h304' : this.props.drawType == 15 ? 'pick3popupLeftBox' : ''}`} >
            //                         {<div className="prizeBreak">{t('lblPriceBreak')}</div>}
            //                         <>
            //                             <div>
            //                                 {this.state.breakdownlist && this.state.breakdownlist.length > 0 && this.state.breakdownlist.map((obj, inx) =>
            //                                     <div className={`matches${this.props.drawType != 15 ? ' customFont-12 matches2' : ''}`} key={`ap_${inx}`}>
            //                                         {this.props.drawType != 15 ? <div className={`formatOutOf !opacity-100${this.props.drawType == 2 && inx == 0 ? " !text-right" : ""}`} >{obj.matchingball} {t('lblOutOf')} {obj.max_ball}</div>
            //                                             : <div className={`formatOutOf  !opacity-100`} >{obj.matchingball}</div>}
            //                                         <div className={`font700${this.props.drawType == 15 ? ' w-100px' : ''}`} ><span>{this.props.appvariables.currency} </span>{commonClass.aedCrnyConvert(obj.winamt)} {obj.addstar && obj.addstar == 1 ? "*" : " "}</div>
            //                                     </div>
            //                                 )}
            //                             </div>
            //                         </>
            //                     </div>
            //                     <div className="pick3popupRightBox">
            //                         <div className="prizeBreak text-center">{t('lblMainDrawResult')}</div>
            //                         <div className="matches">
            //                             <div>{t('lblWinningCombination')} : &nbsp;&nbsp;&nbsp;&nbsp;</div>
            //                             <div>
            //                                 <div className={`winningCombo winningCombo2 bg-game${this.props.drawType}`}>
            //                                     {this.props.PastDrawStateObj.win_number && this.props.PastDrawStateObj.win_number.split(';').length > 0 && this.props.PastDrawStateObj.win_number.split(';').map((winNos, inx) =>
            //                                         <span key={`aq_${inx}`}>{winNos}</span>
            //                                     )}
            //                                 </div>
            //                             </div>
            //                         </div>
            //                         <div className="matches margin-top10">
            //                             <div >{t('lblTotalPrize')} :</div>
            //                             <div className="totalPrize"><span>{this.props.appvariables.currency}</span> &nbsp;{commonClass.aedCrnyConvert(this.props.PastDrawStateObj.total_prize)}</div>
            //                         </div>
            //                         <div className="matches margin-top10">
            //                             <div >{t('lblTotwinner')} :</div>
            //                             <div className="totalPrize">{this.props.PastDrawStateObj.total_winner}</div>
            //                         </div>

            //                     </div>
            //                 </div>
            //                 Main Draw Winners
            //                 {(unique && unique.length > 0) ? unique.map((obj, inx) =>
            //                     <>
            //                         {obj == 1 && <div className="textHeader margin-top2">{t('lblMainDrawWin')}</div>}
            //                         {obj == 2 && <div className="textHeader margin-top2">{t('lblRaffleWinners')}</div>}
            //                         <div className={obj == 2 ? `winnersList marginTopNone` : `winnersList bg-game${this.props.drawType}fade15 border-radius-none`} key={`as_${inx}`}>
            //                             {this.state.RaffleResult.filter(result => result.draws_type == obj).map((result, index) =>
            //                                 <>
            //                                     {this.props.drawType != 13 ? <div className="winnersListAlign" key={`at_${index}`}>
            //                                         <div className="firstColumnName">
            //                                             <div>{result.Player_name}</div>
            //                                             <div>{result.Player_age} {result.Player_age ? " " + t('lblOld') : ""}  {result.Player_city ? " " + t('lblFrom') + " " : ""}<span>{result.Player_city}</span></div>
            //                                         </div>
            //                                         <div className="secondColumnDetails">
            //                                             <div className={`${obj == 2 ? 'flex items-center' : ''}`} ><span>{obj == 2 ? <span>{t('lblRafflaID')}:</span> : <span className="text-right">{t('lblPurchase')}  :</span>}</span>
            //                                                 {obj == 2 ? <span> #{result.raffleid}</span> :
            //                                                     <span className={`winningCombo bg-game${this.props.drawType}`}>
            //                                                         {this.props.drawType != 15 ?
            //                                                             result.raffleid && result.raffleid.split(';').map((ballNo, ind) =>
            //                                                                 <span key={`au_${ind}`} style={{ fontWeight: "normal" }}>{ballNo}</span>
            //                                                             )
            //                                                             :
            //                                                             <>
            //                                                                 {result.raffleid && result.raffleid.split('^')[0].split(';').map((ballNo, ind) =>
            //                                                                     <span key={`au_${ind}`} style={{ fontWeight: "normal" }}>{ballNo}</span>
            //                                                                 )}
            //                                                                 {result.raffleid.split('^').length > 1 &&
            //                                                                     <div className="gameTypeBtn gameTypeBtn3 border-left-0 gridUnset">
            //                                                                         <a className="bg-white margin-0-auto">{result.raffleid.split('^')[1]}</a>
            //                                                                     </div>}
            //                                                             </>
            //                                                         }
            //                                                     </span>
            //                                                 }

            //                                             </div>
            //                                             <div><span >{t('lblWon')}:</span> <span> {this.props.appvariables.currency} {commonClass.aedCrnyConvert(result.winamount)}</span></div>
            //                                         </div>
            //                                     </div>
            //                                         :
            //                                         this.props.drawType == 13 && <div className="winnersListAlign cont-align-items">
            //                                             <div className="firstColumnName w33">
            //                                                 <div>{result.Player_name}</div>
            //                                                 <div>{result.Player_age} {result.Player_age ? " " + t('lblOld') : ""}  {result.Player_city ? " " + t('lblFrom') + " " : ""}<span>{result.Player_city}</span></div>
            //                                             </div>
            //                                             <div className="secondColumnDetails w33">
            //                                                 <div className="flex items-center"><span>{t('lblWon')}:</span> <span> {this.props.appvariables.currency} {commonClass.aedCrnyConvert(result.winamount)} </span></div>
            //                                             </div>
            //                                             <div className="secondColumnDetails w33">
            //                                                 <>
            //                                                     <span>{obj == 2 ? <span>{t('lblRafflaID')}:</span> : <span className="text-right custom-line-height">{t('lblPurchase')}:</span>}</span>
            //                                                     {obj == 2 ? <span> #{result.raffleid}</span> :
            //                                                         <>
            //                                                             {result.raffleid && result.raffleid.split(';').map((ballNo, index) =>
            //                                                                 <ul className="zodiacBallSec Latestlukyresult" key={`au_${index}`}>
            //                                                                     <li id={`ball_${index}`}>
            //                                                                         <a className={`game-13-balls-${parseInt(ballNo)} game-13`}>
            //                                                                             <span>{ballNo}</span>
            //                                                                         </a></li>
            //                                                                 </ul>
            //                                                             )}
            //                                                         </>
            //                                                     }

            //                                                 </>

            //                                             </div>
            //                                         </div>}
            //                                 </>
            //                             )}
            //                         </div >
            //                     </>)
            //                     :
            //                     <div className={`winnersList ${this.props.drawType == 1 ? "bg1Fade15" : "bg2Fade15"} border-radius-none`}>
            //                         <p className='marginAuto' style={{ textAlign: "center" }}>{t('lblresultprogress')}</p>
            //                     </div>
            //                 }
            //             </div>

            //             <button className="capitalize py-1 px-5 !text-white font-semibold mx-auto !bg-brand rounded-md close-popup1 border-2 bigpopupclose">
            //                 {t('lblclose')}
            //             </button>
            //         </div>
            //     </div>
            // </div >
        )
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { previousResult, RaffleResult } = state.gameReducer;
    return { user, previousResult, RaffleResult, appvariables };
}
const mapActionToProps = {
    alertError: alertActions.error,
    GetPreviousResult: gameActions.GetPreviousResult,
    GetRaffleResults: gameActions.GetRaffleResults,
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(WinnersList))
